<template>
  <div class="RouteContainer">
    <app-gallery-section :sectionIndex="4"/>
  </div>
</template>

<script>
import appGallerySection from './../gallery/gallery-section'

export default {
  name: 'WolvesAndPeople',

  components: {
    appGallerySection
  }
}
</script>



// WEBPACK FOOTER //
// src/components/routes/wolves-and-people.vue